<template>
    <main class="expense-edit-page">
        <section class="expense-edit-card">
            <header class="expense-edit-header">
                <div class="expense-edit-title">
                    <el-button class="expense-back-button" icon="el-icon-arrow-left"
                               @click.native.prevent="goBack"></el-button>
                    <h1>Add Expense</h1>
                </div>
                <el-button class="expense-save-button" type="primary" :disabled="buttonDisabledStatus"
                           @click.native.prevent="createExpense">Save and Close</el-button>
            </header>

            <el-form class="expense-modern-form" label-width="0px" v-loading="loading">
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Description</span>
                    <el-input class="expense-line-textarea" type="textarea" :autosize="{minRows: 1}"
                              v-model="expense.expenseDescription"
                              placeholder="Expense description"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Total</span>
                    <el-input class="expense-line-input" :maxlength="15" @keyup.native="formatNow1"
                              @blur="formatTotalNumberBlur(expense.total)" v-model="expense.total"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Tax</span>
                    <el-input class="expense-line-input" :maxlength="15" @keyup.native="formatNow1"
                              @blur="formatTaxNumberBlur(expense.tax)" v-model="expense.tax"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Tip</span>
                    <el-input class="expense-line-input" :maxlength="15" @keyup.native="formatNow1"
                              @blur="formatTipNumberBlur(expense.tip)" v-model="expense.tip"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Expense Date</span>
                    <el-date-picker class="expense-line-date" :editable=false type="date"
                                    format="MMM dd, yyyy" v-model="expense.expenseDate" :clearable=false></el-date-picker>
                </el-form-item>
                <el-form-item class="expense-form-row">
                    <span class="expense-form-label">Merchant</span>
                    <el-input class="expense-line-input" v-model="expense.merchant"
                              placeholder="Enter merchant name"></el-input>
                </el-form-item>
                <el-form-item class="expense-form-row expense-category-row">
                    <span class="expense-form-label">Category</span>
                    <div class="expense-category-control">
                        <el-select class="expense-line-select" v-model="expense.categoryUUID" placeholder="Select category">
                            <el-option v-for="item in categoryList"
                                       :key="item.innerUUID"
                                       :label="item.name"
                                       :value="item.innerUUID">
                            </el-option>
                        </el-select>
                        <el-button class="expense-add-category-button" type="text" @click="openCategoryDiagory">
                            <span class="expense-add-category-icon"><i class="el-icon-plus"></i></span>
                            <span>Add new category</span>
                        </el-button>
                    </div>
                </el-form-item>

                <div class="expense-photo-list" v-if="activeFileList.length > 0">
                    <div class="expense-photo-card" v-for="file in activeFileList" :key="file.innerUUID">
                        <img class="expense-photo-preview" :src="file.url" alt="">
                        <el-button class="expense-photo-delete" @click="handleRemove(file.innerUUID)" type="text">Delete</el-button>
                    </div>
                </div>

                <div class="expense-upload-row" v-if='activeFileList.length==0'>
                    <el-upload
                            multiple
                            :action=requestURL
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :before-upload="onBeforeUpload"
                            :data="uploadData"
                            accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PBG,.BMP">
                        <el-button class="expense-upload-button" :loading="attachPhotosStatus">
                            <span class="expense-upload-icon"><i class="el-icon-paperclip"></i></span>
                            <span class="expense-upload-text">
                                <strong>Add photo</strong>
                            </span>
                        </el-button>
                    </el-upload>
                </div>

                <el-dialog title="" :visible.sync="categoryDiagoryStatus" width="720px"
                           custom-class="expense-category-dialog">
                            <div class="expense-category-dialog-list">
                                <template v-for="item in categoryList">
                                <div class="expense-category-dialog-row" :key="item.innerUUID" v-if="item.syncStatus!=1">
                                    <span v-if="item.isNew!=1" class="expense-category-dialog-name">{{ item.name }}</span>
                                    <el-input v-else class="expense-category-dialog-input" v-model="item.name"></el-input>
                                    <el-button v-if="item.isNew!=1" class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,item.isNew)">delete</el-button>
                                    <el-button v-else class="expense-category-dialog-delete" type="text"
                                               @click="deleteCategory(item.innerUUID,1)">delete</el-button>
                                </div>
                                </template>
                            </div>
                            <el-button class="expense-category-dialog-add" type="text" @click="addCategory()">
                                <span class="expense-category-dialog-add-icon"><i class="el-icon-plus"></i></span>
                                <span>Add category</span>
                            </el-button>
                            <div slot="footer" class="dialog-footer">
                                <el-button class="expense-category-dialog-close" @click="categoryDiagoryStatus=false">Close</el-button>
                            </div>
                        </el-dialog>
            </el-form>
        </section>
    </main>
</template>

<script>
    import {uuid, timest, toTmpTime} from '@/utils/validate'
    import {formatNow, formatAtCreate} from '@/utils/numberFormat'
    import {
        EXPENSE_IMAGES_FOLDER,
        getDownloadV2Url,
        getUploadRemoteKey,
        prepareFileUpload,
        takeUploadInnerUUID
    } from '@/utils/fileUpload'


    export default {
        data() {
            return {
                buttonDisabledStatus: false,
                expense: {
                    "expenseDate": new Date(),
                    "categoryUUID": ""
                },
                fileList: [],
                attachPhotosStatus: false,
                requestURL: "",
                uploadData: {
                    email: ""
                },
                uploadFileMap: {},
                loading: false,
                categoryList: [],
                categoryDiagoryStatus: false,
                newCategoryList: []
            }
        },
        computed: {
            activeFileList() {
                return this.fileList.filter(file => file.syncStatus != 1);
            }
        },

        methods: {
            formatNow1: formatNow,
            formatTotalNumberBlur(item) {
                this.expense.total = formatAtCreate(item);
            },
            formatTaxNumberBlur(item) {
                this.expense.tax = formatAtCreate(item);
            },
            formatTipNumberBlur(item) {
                this.expense.tip = formatAtCreate(item);
            },
            getExpenseImageUrl(imagePath, remoteKey) {
                if (null != remoteKey && "" != remoteKey) {
                    return getDownloadV2Url(this.$store.state.requestURL, remoteKey);
                }
                return this.$store.state.requestURL + "/file/download?fileName=" + imagePath + "&email=" + JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            },
            buildExpenseImageForRequest(fileInfo, expenseUUID, syncStatus) {
                if (fileInfo.remoteKey == null || fileInfo.remoteKey === '') {
                    throw new Error('remoteKey is required for new expense image');
                }
                return {
                    accessDate: timest(),
                    createDate: timest(),
                    imageIsNew: 0,
                    imagePath: fileInfo.imagePath,
                    innerUUID: fileInfo.innerUUID,
                    expenseUUID: expenseUUID,
                    syncStatus: syncStatus,
                    remoteKey: fileInfo.remoteKey,
                    transferStatusRaw: 1,
                    imageSchemaVersion: 1
                };
            },
            openCategoryDiagory() {
                this.categoryDiagoryStatus = true;
            },
            goBack() {
                let self = this;
                self.$router.push('/expense');
            },
            addCategory() {
                let newObj = {
                    "name": "",
                    "innerUUID": uuid(null, 37),
                    "syncStatus": 0,
                    "isNew": 1
                };
                this.categoryList.push(newObj);
            },
            deleteCategory(innerUUID, oldOrNew) {
                if (oldOrNew == 0 || oldOrNew == undefined) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList[i].syncStatus = 1;
                            break;
                        }
                    }
                } else if (oldOrNew == 1) {
                    for (let i = 0; i < this.categoryList.length; i++) {
                        if (this.categoryList[i].innerUUID == innerUUID) {
                            this.categoryList.splice(i--, 1);
                            break;
                        }
                    }
                }
            },
            createExpense() {
                let that = this;

                let createCategoryList = [];
                for (let i = 0; i < this.categoryList.length; i++) {
                    let category = this.categoryList[i];
                    //删除的category
                    if (category.syncStatus == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 1,
                            fromClient: 3
                        };
                        createCategoryList.push(needCreateCategory);
                    }

                    if (category.isNew == 1) {
                        let needCreateCategory = {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: category.innerUUID,
                            isDelete: 0,
                            name: category.name,
                            syncStatus: 0,
                            fromClient: 3
                        };
                        createCategoryList.push(needCreateCategory);
                    }

                }
                //新创建的category
                /*for (let i = 0; i < this.newCategoryList.length; i++) {
                    let category = this.newCategoryList[i];
                    //删除的category
                    let needCreateCategory = {
                        accessDate: timest(),
                        createDate: timest(),
                        innerUUID: category.innerUUID,
                        isDelete: 0,
                        name: category.name,
                        syncStatus: 0,
                        fromClient: 3
                    };
                    createCategoryList.push(needCreateCategory);
                }*/


                let expenseUUID = uuid(null, 37);
                let activeImage = this.activeFileList.length > 0 ? this.activeFileList[0] : null;
                this.$axios.post('web_create_expense', {
                    params: {
                        "expense": {
                            accessDate: timest(),
                            createDate: timest(),
                            innerUUID: expenseUUID,
                            expenseDate: toTmpTime(that.expense.expenseDate),
                            expenseDescription: that.expense.expenseDescription,
                            imageIsNew: 0,
                            imagePath: "",
                            merchant: that.expense.merchant,
                            tax: that.expense.tax == null || that.expense.tax == '' ? 0 : that.expense.tax,
                            tip: that.expense.tip == null || that.expense.tip == '' ? 0 : that.expense.tip,
                            total: that.expense.total == null || that.expense.total == '' ? 0 : that.expense.total,
                            categoryUUID: that.expense.categoryUUID,
                            expenseImageUUIDArrayKey: activeImage != null ? activeImage.innerUUID : "",
                            syncStatus: 0,
                            fromClient: 3
                        },
                        "categoryList": createCategoryList,
                        companyLogo: activeImage != null ? this.buildExpenseImageForRequest(activeImage, expenseUUID, 0) : null
                    }
                }).then(response => {
                    this.loading = false;
                    that.buttonDisabledStatus = false;
                    if (response.data.errorCode === 0) {
                        that.$router.push('/expense');
                    }
                }).catch(function () {
                    that.loading = false;
                    that.buttonDisabledStatus = false;
                })
            },

            queryCategoryList() {
                this.loading = true;
                this.buttonDisabledStatus = true;
                let that = this;
                this.$axios.post('query_category_list', {
                    params: {}
                }).then(response => {
                    let categoryList = JSON.parse(JSON.stringify(response.data.dataList));
                    for (let i = 0; i < categoryList.length; i++) {
                        let category = categoryList[i];
                        if (category.syncStatus != 1) {
                            this.categoryList.push(category);
                        }
                    }
                    that.loading = false;
                    that.buttonDisabledStatus = false;
                }).catch(function () {
                    that.loading = false;
                    that.buttonDisabledStatus = false;
                })
            },
            ///////////////上传///////////////
            handleRemove(fileName) {
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].innerUUID === fileName) {
                        this.fileList.splice(i--, 1);
                    }
                }
            },
            onBeforeUpload(file) {
                prepareFileUpload(this.uploadData, this.uploadFileMap, file, EXPENSE_IMAGES_FOLDER);
                this.attachPhotosStatus = true;
            },
            handlePictureCardPreview() {

            },
            handleSuccess(res, file) {
                this.attachPhotosStatus = false;
                this.$message({
                    type: 'info',
                    message: 'upload success',
                    duration: 6000
                });
                if (file.response.errorCode === 0) {
                    const innerUUID = takeUploadInnerUUID(this.uploadFileMap, file);
                    const remoteKey = getUploadRemoteKey(EXPENSE_IMAGES_FOLDER, innerUUID);
                    let fileList = file.response.uploadFileList;
                    for (let i = 0; i < fileList.length; i++) {
                        let fileInfo = {
                            url: getDownloadV2Url(this.$store.state.requestURL, remoteKey),
                            innerUUID: innerUUID,
                            imagePath: innerUUID + ".jpg",
                            remoteKey: remoteKey,
                            syncStatus: 0
                        };
                        this.fileList.push(fileInfo);
                    }
                }
            },
            ///////////////上传///////////////

        },
        mounted() {
            this.queryCategoryList();
            this.requestURL = this.$store.state.requestURL + "/file/upload";
            this.uploadData.email = JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
        }
    }
</script>
